<template>
  <div class="row clearfix">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="card">
        <div class="header">
          <h2><strong>앱 목록</strong></h2>
          <ul class="header-dropdown">
            <li class="dropdown">
              <router-link to="/develop/create"
              ><button class="btn btn-primary" type="button">
                신규 생성
              </button></router-link
              >
            </li>
          </ul>
        </div>
        <div class="body">
          <div class="table-responsive" v-if="this.list.length > 0">
            <table class="table">
              <thead>
              <tr>
                <th scope="row">#</th>
                <th></th>
                <th>이름</th>
                <th>버전</th>
                <th>생성일</th>
                <th>공개</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(each, index) in list" v-bind:key="index">
                <th scope="row">{{ index + 1 }}</th>
                <td class="width45">
                  <img
                    :src="imagePaths(each.appImage)"
                    class="w60 rounded"
                    alt="Rounded Image"
                  />
                </td>
                <td>
                  <button
                    type="button"
                    class="devAppNameBtns"
                    @click="iWantThisApp(each.appCode, index)"
                  >
                    {{ each.appName }}
                  </button>
                </td>
                <td>{{ each.versionCode }}</td>
                <td>{{ setInsertDt(each.insertDt) }}</td>
                <td>{{ setYesNo(each.viewYn) }}</td>
                <td>
                  <a
                    href="javascript:void(0);"
                    @click="toEditPage(each.appCode, each.appName)"
                  >수정</a
                  >&nbsp;&nbsp;&nbsp;
                  <a href="javascript:void(0);" @click="removePage(index)"
                  >삭제</a
                  >
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="table-responsive" v-if="this.list.length == 0">
            <div>생성된 앱목록이 없습니다.</div>
          </div>
        </div>
      </div>
      <!-- <paginate /> -->
    </div>
  </div>
</template>


<script>
export default {
  name: 'DevelopPage',
  components: {
  },
  data() {
    return {
      dropdown: false,

      list: [],
    }
  },
  methods: {
    checkAddress() {
      console.log(this.$store.state.devStore.urlType);
      return this.$store.state.devStore.urlType;
    },
    iWantThisApp(code, index) {
      console.log(this.list[index]);
      var name = this.list[index].appName;

      this.$store.state.devStore.appCode = code;
      this.$store.state.devStore.appData = this.list[index];
      console.log(this.$store.state.devStore.appData);
      this.$router.push({name:"DevelopAppPage", params : {appId : name }})

      // this.$router.push({
      //   name: "DevSecondLayout",
      //   params: { checkType: this.radioValue, appCode: code, appId: name },
      // });
    },
    showDropList(index) {
      console.log(this.$refs.dropUlHidden[index].style.display);
      for (var i = 0; i < this.$refs.dropUlHidden.length; i++) {
        if (i != index) {
          this.$refs.dropUlHidden[i].style.display = "none";
        }
      }

      if (this.$refs.dropUlHidden[index].style.display == "none") {
        this.$refs.dropUlHidden[index].style.display = "block";
        return;
      }

      if (this.$refs.dropUlHidden[index].style.display == "block") {
        this.$refs.dropUlHidden[index].style.display = "none";
        return;
      }
    },
    toEditPage(code, value) {
      this.$store.state.devStore.appCode = code;
      this.$router.push({
        name: "DevelopCreatePage",
        params: { appCode: code, appId: value },
      });
    },
    imagePaths(value) {
      if (value != null && value != "") {
        return (
          "https://frients-smartservice.s3.ap-northeast-2.amazonaws.com/" +
          value
        );
      } else {
        return "https://frients-smartservice.s3.ap-northeast-2.amazonaws.com/common/noimage.jpg";
      }
    },
    setDropdown(index) {
      return "dropdown" + index;
    },
    removePage(index) {
      if(confirm('삭제하시겠습니까?')){
        var param = {
          appCode: this.list[index].appCode,
        };

        this.api.appRemove(param)
          .then((res) => {
            console.log(res);

            if(this.utils.preApiHandle(res)) {
              console.log("dev create page res : ", res)
            }

            //전체 삭제하는 경우에만 이미지 삭제되게하기

            // if (this.list[index].appImage != null) {
            //   var image = this.list[index].appImage;
            //
            //   this.$store.dispatch("removeImage", { file: image }).then(() => {
            //     this.updateList();
            //   });
            // } else {
            this.updateList();
            // }
          })
          .catch(() => alert("오류가 발생했습니다."));

      }
    },
    updateList() {
      var innerParam = {
        userCode: this.$store.state.userStore.userCode,
      };

      this.api.appSelect(innerParam)
        .then((res) => {

          if(this.utils.preApiHandle(res)) {
            console.log("dev create page res : ", res)
          }

          console.log(res);
          this.list = res.app;
        })
        .catch(() => alert("오류가 발생했습니다."));
    },
    setInsertDt(createDt) {
      console.log(createDt.substring(0, 10));

      return createDt.substring(0, 10);
    },
    setYesNo(yesNo){

      var aa = "공개";
      if(yesNo == "N"){
        aa = '비공개';
      }
      return aa;

    }
  },
  created() {
    console.log('DevelopPage created')
    var param = {
      userCode: this.$store.getters.getUserCode,
    };

    this.api.appSelect(param)
      .then((res) => {
        console.log(res);
        if(this.utils.preApiHandle(res)) {

          console.log("dev front page res : ", res)
        }

        this.list = res.app;
      })
      .catch(() => alert("오류가 발생했습니다."));
  },
  mounted() {
    console.log('DevelopPage created')
  },
  beforeDestroy() {
    console.log('DevelopPage beforeDestroy')
  }
}
</script>

